import { t } from "@lingui/macro";
import { ShieldCheck, Sparkles, Target, Users } from "lucide-react";

import { Seo } from "@/client/components/seo";

import { CtaBand, FeatureCard, PageHero, Section, SectionHeading } from "../_components/page-shell";

export const AboutPage = () => {
  const values = [
    {
      icon: Target,
      title: t`Roles that fit you`,
      description: t`Izicvs finds openings from official sources and ranks them against your resume, so you focus on the jobs where you have a real chance.`,
    },
    {
      icon: Sparkles,
      title: t`Tailored in seconds`,
      description: t`For every role, Izicvs adapts your CV and drafts a matching cover letter, keeping your voice while highlighting what each employer is looking for.`,
    },
    {
      icon: ShieldCheck,
      title: t`Organized applications`,
      description: t`Prepare, send, and track your applications in one place. Nothing slips through the cracks, from first draft to final follow up.`,
    },
    {
      icon: Users,
      title: t`An agent on your side`,
      description: t`Turn on the optional autonomous agent and let Izicvs search, tailor, and apply on your behalf while you stay in control.`,
    },
  ];

  return (
    <>
      <Seo
        title={t`About Izicvs`}
        description={t`Izicvs is an AI powered job search platform by Nextilabs, turning the scattered job hunt into one guided flow from finding roles to sending standout applications.`}
        path="/about"
        breadcrumb={t`About`}
      />

      <PageHero
        eyebrow={t`About`}
        title={t`We help you land the job, not just build a resume`}
        subtitle={t`Izicvs is an AI powered job search platform by Nextilabs. We turn the slow, scattered job hunt into one guided flow, from finding the right roles to sending applications that stand out.`}
      />

      <Section>
        <SectionHeading
          title={t`Our mission`}
          subtitle={t`Searching for work should not feel like a second job. We built Izicvs to give every candidate the tools that were once reserved for insiders: clear signal on where to apply, resumes tuned to each role, and a calm way to manage it all. Our goal is simple. Help you spend less time on busywork and more time getting hired.`}
        />
      </Section>

      <Section className="pt-0">
        <SectionHeading title={t`What makes Izicvs different`} />
        <div className="mx-auto grid max-w-5xl gap-6 sm:grid-cols-2">
          {values.map(({ icon, title, description }, index) => (
            <FeatureCard
              key={title}
              icon={icon}
              title={title}
              description={description}
              index={index}
            />
          ))}
        </div>
      </Section>

      <CtaBand
        title={t`Ready to find your next role?`}
        description={t`Join the candidates who let Izicvs do the heavy lifting. It takes a minute to get started, and you can explore everything for free.`}
        ctaLabel={t`Start for free`}
        to="/auth/register"
      />
    </>
  );
};
